//@ts-nocheck
import { createContext } from "react";

const AnimationThemeContext = createContext<any>();

export default AnimationThemeContext;
